import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Field, Form as FormikForm, Formik } from "formik";
import api from "common/api";
import { ICourse } from "common/types";
import hr from "date-fns/locale/hr"; // Import the hr locale

interface NewAppointmentModalProps {
  show: boolean;
  onHide: () => void;
  selectedDate: Date | null;
  course: ICourse;
  refreshAppointments: () => void;
}

const NewAppointmentModal: React.FC<NewAppointmentModalProps> = ({
  show,
  onHide,
  selectedDate,
  course,
  refreshAppointments,
}) => {
  const handleSubmit = async (values: any) => {
    if (values.startDate && values.endDate && values.meetingUrl) {
      try {
        await api.post("/appointments/", {
          start: values.startDate.toISOString(),
          end: values.endDate.toISOString(),
          meet_url: values.meetingUrl,
          course: course.id,
          text: "",
        });

        refreshAppointments();
        onHide();
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Novi termin</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          startDate: selectedDate,
          endDate: selectedDate,
          meetingUrl: "",
        }}
        onSubmit={handleSubmit}
      >
        <FormikForm>
          <Modal.Body>
            <Row className="mb-3 align-items-center">
              <Col md={4} className="align-self-center">
                <Form.Label>Početak </Form.Label>
              </Col>
              <Col md={8}>
                <Field name="startDate">
                  {({ field, form }: any) => (
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date: Date | null) =>
                        form.setFieldValue(field.name, date)
                      }
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="Vrijeme"
                      dateFormat="dd.MM.yyyy HH:mm"
                      locale={hr}
                      placeholderText="Odaberi početak prvog termina"
                      className="form-control"
                      wrapperClassName="w-100"
                      showIcon
                      customInput={<Form.Control />}
                    />
                  )}
                </Field>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col md={4} className="align-self-center">
                <Form.Label>Kraj</Form.Label>
              </Col>
              <Col md={8}>
                <Field name="endDate">
                  {({ field, form }: any) => (
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date: Date | null) =>
                        form.setFieldValue(field.name, date)
                      }
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="Vrijeme"
                      dateFormat="dd.MM.yyyy HH:mm"
                      locale={hr}
                      placeholderText="Odaberi kraj prvog termina"
                      className="form-control"
                      wrapperClassName="w-100"
                      showIcon
                      customInput={<Form.Control />}
                    />
                  )}
                </Field>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col md={4} className="align-self-center">
                <Form.Label>Meeting URL</Form.Label>
              </Col>
              <Col md={8}>
                <Field name="meetingUrl" as={Form.Control} type="text" />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">
              Izradi termin
            </Button>
          </Modal.Footer>
        </FormikForm>
      </Formik>
    </Modal>
  );
};

export default NewAppointmentModal;
